import { Typography } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid";
import React from "react";

interface CustomNoRowsOverlayProps {
    message: string;
}

export default function CustomNoRowsOverlay(props: CustomNoRowsOverlayProps) {
    const message = props.message;
    return (
      <GridOverlay>
        <Typography variant="body2" color="textSecondary">
          {message} 
        </Typography>
      </GridOverlay>
    );
}